(function () {
  function initializeProductCardSwipers(root) {
    if (typeof Swiper === "undefined") {
      return;
    }

    var scope = root || document;
    var containers = scope.querySelectorAll("[data-product-card-swiper]");
    if (!containers.length) {
      return;
    }

    containers.forEach(function (container) {
      var swiperId = container.getAttribute("data-swiper-id");
      var slides = container.querySelectorAll(".swiper-slide");
      var hasMultiple = slides.length > 1;

      // If already initialized (e.g., hidden tab panel), just re-measure now.
      if (container.swiper && typeof container.swiper.update === "function") {
        container.swiper.update();
        return;
      }

      var prevSelector = '[data-swiper-prev="' + swiperId + '"]';
      var nextSelector = '[data-swiper-next="' + swiperId + '"]';
      var paginationSelector = '[data-swiper-pagination="' + swiperId + '"]';

      var prevEl = document.querySelector(prevSelector);
      var nextEl = document.querySelector(nextSelector);
      var paginationEl = document.querySelector(paginationSelector);

      var options = {
        loop: hasMultiple,
        speed: 400,
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true,
      };

      if (hasMultiple) {
        if (prevEl && nextEl) {
          options.navigation = {
            prevEl: prevEl,
            nextEl: nextEl,
          };
        }

        if (paginationEl) {
          options.pagination = {
            el: paginationEl,
            clickable: true,
          };
        }
      }

      // eslint-disable-next-line no-new
      new Swiper(container, options);
      container.setAttribute("data-swiper-initialized", "true");
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initializeProductCardSwipers(document);
  });

  document.addEventListener("product-recommendations:loaded", function (event) {
    var target = event.target || document;
    initializeProductCardSwipers(target);
  });

  document.addEventListener("featured-collections:tab-changed", function (event) {
    var toPanel = event && event.detail ? event.detail.toPanel : null;
    initializeProductCardSwipers(toPanel || document);
  });
})();
